function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m515.556 257.779c-37.609-112.56-138.666-193.334-257.778-193.334-42.638 0-82.851 10.524-118.747 29.022l-61.245-61.244-45.564 45.564 405.546 405.546 45.564-45.564-52.501-52.501c38.23-33.21 67.884-77.094 84.723-127.491zm-257.778-128.889c71.184 0 128.889 57.705 128.889 128.889 0 23.899-6.779 46.04-18.206 65.119l-48.444-48.444c1.436-5.312 2.205-10.899 2.205-16.676 0-35.593-28.853-64.444-64.444-64.444-5.758 0-11.283.869-16.583 2.297l-48.141-48.141c19.051-11.402 40.862-18.6 64.724-18.6z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m257.778 386.668c-71.184 0-128.889-57.706-128.889-128.889 0-11.47 1.977-22.387 4.789-32.971l-72.03-72.03c-27.077 29.651-48.377 65.282-61.648 105.001 37.609 112.56 138.666 193.333 257.778 193.333 30.476 0 59.74-5.357 87.093-15.112l-54.121-54.121c-10.585 2.812-21.503 4.789-32.972 4.789z"
});

var SvgIconEyeHide = function SvgIconEyeHide(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 515.556 515.556",
    width: 512,
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconEyeHide, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-eye-hide.2064022c.svg";
export { ForwardRef as ReactComponent };